import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { MemberListRequestBody, MemberListResponse } from "./types";

export class MemberListAPI extends BaseAPI<
    MemberListRequestBody,
    MemberListResponse
> {
    protected route = ApiRoutes.member.list;
    protected method = RequestMethod.GET;
}
